<template>
  <v-row>
      <v-col xs-12>
        <v-row>
          <v-col>
            <v-card>
              <v-toolbar>Tracking Info</v-toolbar>
              <v-card-text>
                Tracking Id: {{ handling.shippingTracking.tracking_id}}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="mb-2">
              <v-toolbar flat color="secondary" dark>
                <v-icon left>mdi-format-list-bulleted</v-icon>
                <v-toolbar-title>Products sent</v-toolbar-title>
              </v-toolbar>
              <v-simple-table>
                <template #default>
                  <thead>
                    <tr>
                      <td>Product Name</td>
                      <td>Quantity</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in handling.items" :key="'_shipped_item_'+item.id">
                      <td>{{ item.product.name }}</td>
                      <td>{{ item.quantity }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>

export default {
    components:{
    },
    props:{
        value: {
            type:Object,
            required:true
        },
        handling: {
          type:Object,
          required:true
        }
    },
    computed:{
        model:function(){
            return this.value;
        },
        items(){
          return this.model.rows.filter(row => row.handling_id == this.handling.id)
        }
    },
}
</script>

<style>

</style>